<script>
    import Lge from './Lge.svelte';
    import Fix from './Fix.svelte';
    import Cmp from './Cmp.svelte';
    import Router from 'svelte-spa-router';
    const routes = {
        '/': Lge,
        '/fix/:id': Fix,
        '/cmp/': Cmp
       // Catch-all '*': NotFound,
    }

</script>

 <Router {routes}/>